export default function (materials, filters, searchString) {
  const jsFilters = filters.toJS();

  // search string
  const searchFilter = material => material.title
                                    .toLowerCase()
                                    .trim()
                                    .indexOf(searchString.toLowerCase()) >= 0;
  if (searchString.trim() !== '') {
    materials = materials.filter(searchFilter);
  }

  // character filters
  const chosenCharacters = jsFilters.characters.filter(f => f.value).map(f => f.id);
  if (chosenCharacters.length) {
    materials = materials.filter(m => m.character && chosenCharacters.indexOf(m.character.name.toLowerCase()) >= 0)
  }

  // grade filters
  const chosenGrades = jsFilters.grades.filter(o => o.value).map(o => o.id);
  if (chosenGrades.length) {
    materials = materials.filter(m => m.grades.map(g => g.long.toLowerCase()).some(g => chosenGrades.indexOf(g) >= 0));
  }

  const chosenOthers = jsFilters.other.filter(f => f.value)

  // assembly filter
  if (chosenOthers.some(f => f.id === 'assembly')) {
    materials = materials.filter(m => m.assembly);
  }

  // general filter
  if (chosenOthers.some(f => f.id === 'general')) {
    const generalFilter = m => m.grades.length === 0 ||
                               m.grades.length === jsFilters.grades.length ||
                               !m.character;

    materials = materials.filter(generalFilter);
  }

  return materials;
}



// WEBPACK FOOTER //
// ./app/features/library/services/MaterialFilterService.js